import * as React from 'react';
import { Calendar } from '../../Calendar/src/Calendar.js';
import { Portal } from '../../Portal/src/Portal.js';
import { Fade } from '../../Transition/src/Fade.js';
import '../../Transition/src/ScaleFade.js';
import '../../Transition/src/SlideFade.js';
import '../../Transition/src/Collapse.js';

const CalendarView = (props) => {
    const { visible, calendarWrapper, popperProps, defaultDate, maxDate, minDate, disabledIntervals, rangeLimit, calendarRef, mode, value, handleChangeSelected, } = props;
    return (React.createElement(Portal, null,
        React.createElement(Fade, { visible: visible, unmountOnExit: true },
            React.createElement("div", { className: calendarWrapper, ...popperProps },
                React.createElement(Calendar, { ref: calendarRef, mode: mode, maxDate: maxDate, minDate: minDate, rangeLimit: rangeLimit, disabledIntervals: disabledIntervals, selection: value, defaultDate: defaultDate, tabIndex: -1, onChange: handleChangeSelected })))));
};

export { CalendarView };
//# sourceMappingURL=CalendarView.js.map
